<template>
  <div>
    <div
      class="rightmouse"
      :style="{ top: rightMouseTop + 'px', left: rightMouseLeft + 'px', opacity: rightMouseFlag ? '1' : '0' }"
    >
      <p>© 图片版权保护</p>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="90%"
      top="12vh"
      :before-close="handleClose"
      :show-close="false"
    >
      <!-- 关闭按钮 -->
      <div @click="handleClose" class="close">
        <img
          :style="{ 'margin-top': displayResolution < 1600 ? '-2px' : '0px' }"
          src="@/assets/picbrowse/close.png"
          alt
        />
      </div>

      <div class="left">
        <div
          class="pic"
          v-loading="imgLoading"
          element-loading-text="正在加载图片中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <div class="imgBj" ref="imgBj">
            <div
              ref="imgPic"
              @contextmenu.prevent="rightShow($event)"
              ondragstart="return false;"
              @click="seeBigSmall"
              :style="{ height: '98%', width: '100%', backgroundImage: 'url(' + choosePicMsg.picThumbW1080 + ')', backgroundSize: 'contain', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat' }"
            ></div>
            <!-- <img ref="imgPic"
                 @contextmenu.prevent="rightShow($event)"
                 ondragstart="return false;"

                 height="98%"
                 @click="seeBigSmall"
            v-lazy="choosePicMsg.picThumbW1080" />-->
            <div @click.stop="bigLeft" class="leftjt">
              <div class="message" v-show="showMessageLeft">这是第一张哟~</div>
            </div>
            <div @click.stop="bigRight" class="rightjt">
              <div class="message" v-show="showMessageRight">这是最后一张哟~</div>
            </div>
            <i
              @click="picRotateRight"
              v-if="seeFull"
              class="el-icon-refresh-right"
              style="  position:absolute; bottom:20px; left:45%; font-size: 30px;"
            ></i>
            <i
              @click="picRotateLeft"
              v-if="seeFull"
              class="el-icon-refresh-left"
              style="position:absolute; bottom:20px;font-size: 30px;"
            ></i>
          </div>

          <!-- <img height="78%" :src="choosePicMsg.src"> -->

          <!-- <div class="picBtn">
          <i @click.stop="picRotateRight"
             class="el-icon-refresh-right"></i>
          <i @click.stop="picLarge"
             class="el-icon-zoom-in"></i>
          <i @click.stop="picSmall"
             class="el-icon-zoom-out"></i>
          <i @click.stop="picRotateLeft"
             class="el-icon-refresh-left"></i>
          </div>-->
        </div>

        <div class="picinf disflex">
          <!-- <p class="picinfleft">
          {{atlasInfo.name}} / 共
          <span>{{atlasInfo.pictureCount}}</span>张
          </p>-->
          <div class="picinfright disflex">
            <!-- <div
            @click.stop="lovePic"
            class="disflex spare"
            :style="{background: !haslovechange ?'url('+ require('@/assets/picbrowse/spare.png') +') no-repeat':'url('+ require('@/assets/picbrowse/sparelove.png') +') no-repeat'}"
          >
            <div class="icon"></div>
            <p>选用</p>
          </div>
          <div @click="setIndexPic" class="disflex book">
            <div class="icon"></div>
            <p>设为封面</p>
          </div>
          <div @click="deletePic" class="disflex delete">
            <div class="icon"></div>
            <p>移除</p>
            </div>-->
            <!-- <div @click.stop="dev" class="disflex download">
              <div class="icon"></div>
              <p>下载原图 <span style="font-size:12px;"> (已下载{{choosePicMsg.downloadCount}}次)</span> </p>
            </div>-->
          </div>
        </div>

        <div ref="piclist" class="piclist">
          <div v-if="picAllListFlag >= 13 || scroll < -1" @click="smallLeft" class="leftjt">
            <i style="font-size:30px;" class="el-icon-arrow-left"></i>
          </div>

          <div ref="picalllist" style="display:flex;transition:1s;">
            <div @click="picListClick(e, i)" v-for="(e,i) in picList" :key="i">
              <!-- <img :src="e.src" :class="picAllListFlag === i || choosePicMsg.id === i ? 'picimg active':'picimg'" /> -->
              <div
                :style="{ backgroundImage: 'url(' + e.src + ')', cursor: 'pointer' }"
                @contextmenu.prevent="rightShow($event)"
                ondragstart="return false;"
                :class="picAllListFlag === i || choosePicMsg.myId === i ? 'picimg active' : 'picimg'"
              ></div>
            </div>
          </div>

          <div v-if="picCha !== scroll && picList.length > 13" @click="smallRight" class="rightjt">
            <i style="font-size:30px;" class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="title">
          <p>图片信息</p>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">上传时间</div>：
          <span>{{ choosePicMsg.fileCreateAt || '暂无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">删除时间</div>：
          <span>{{ choosePicMsg.createAtMy || '暂无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">相机品牌</div>：
          <span>{{ choosePicMsg.Make || '暂无' }}</span>
        </div>
        <div
          v-if="choosePicMsg.fileInfo"
          style="display: flex;margin-bottom: 14px;padding-left:8px;"
        >
          <div style="width:58px;">图片尺寸</div>：
          <span>{{ choosePicMsg.fileInfo.picH }}*{{ choosePicMsg.fileInfo.picW }}</span>
        </div>
        <div
          v-if="choosePicMsg.fileInfo"
          style="display: flex;margin-bottom: 14px;padding-left:8px;"
        >
          <div style="width:58px;">图片大小</div>：
          <span>{{ (choosePicMsg.fileInfo.fileSize / 1024 / 1024).toFixed(2) }}MB</span>
        </div>
        <div
          v-if="choosePicMsg.indexpicInfo"
          style="display: flex;margin-bottom: 14px;padding-left:8px;"
        >
          <div style="width:58px;">图片尺寸</div>：
          <span>{{ choosePicMsg.indexpicInfo.picH }}*{{ choosePicMsg.indexpicInfo.picW }}</span>
        </div>
        <div
          v-if="choosePicMsg.indexpicInfo"
          style="display: flex;margin-bottom: 14px;padding-left:8px;"
        >
          <div style="width:58px;">图片大小</div>：
          <span>{{ (choosePicMsg.indexpicInfo.fileSize / 1024 / 1024).toFixed(2) }}MB</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片格式</div>：
          <span>{{ choosePicMsg.format || '暂无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">曝光时间</div>：
          <span>{{ choosePicMsg.ExposureTime || '暂无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">ISO速度</div>：
          <span>{{ choosePicMsg.ISOSpeedRatings || '暂无' }}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片焦距</div>：
          <span>{{ choosePicMsg.FocalLength || '暂无' }}</span>
        </div>

        <div style="margin-top:25px;" class="title" v-if="choosePicMsg.desc">
          <p>图片说明</p>
        </div>

        <p style="line-height:26px;padding-left:8px;">{{ choosePicMsg.desc }}</p>

        <div
          style="margin-top:25px;"
          class="title"
          v-if="choosePicMsg.labels ? choosePicMsg.labels.length > 0 : false && !isSimple"
        >
          <p>智能标签</p>
          <div class="alert">仅供参考</div>
        </div>

        <div
          v-if="!isSimple"
          style="display:flex;align-items: center;flex-wrap: wrap;width:100%;margin-top:10px;"
        >
          <div
            style="margin-left:5px;margin-bottom:5px;"
            v-for="(e,i) in choosePicMsg.labels"
            :key="i"
          >
            <el-tag>{{ e }}</el-tag>
          </div>
        </div>

        <!-- <div class="msg disflex">
        <div class="picmsg">
          <p>{{choosePicMsg.shareCount}}</p>
          <div>浏览量</div>
          <img src="@/assets/picbrowse/see.png" alt />
        </div>
        <div class="picmsg">
          <p>{{choosePicMsg.pushCount}}</p>
          <div>推送量</div>
          <img src="@/assets/picbrowse/msgpush.png" alt />
        </div>
        <div class="picmsg">
          <p>{{choosePicMsg.downloadCount}}</p>
          <div>平台数</div>
          <img src="@/assets/picbrowse/platform.png" alt />
        </div>
        </div>-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fullScreen, exitFullscreen, checkFull } from "@/plugins/fullScreen";
import { getDate, formatConversion } from "@/plugins/getdate";
export default {
  props: {

    dialogVisible: {
      type: Boolean,
      default: false,
    },
    passChoose: {
      type: Object,
    },
    // atlasInfo: {
    //   type: Object,
    // },
    picList: {
      type: Array,
    },
  },
  watch: {
    dialogVisible: {
      deep: true,
      handler(v) {
        this.dialogVisible = v;
      },
    },
    passChoose: {
      deep: true,
      handler(v) {
        this.passChoose = v;
        this.choosePicMsg = this.passChoose

      },
    },
    picList: {
      deep: true,
      handler(v) {
        this.picList = v;
      },
    },
  },
  data() {
    return {

      seeFull: false,
      choosePicMsg: { labels: [] },
      displayResolution: 0,
      picAllListFlag: -1,
      scroll: 0,
      picCha: -1,
      haslovechange: false,
      imgLoading: false,//图片加载
      picTimes: 1,
      picDeg: 0,

      //鼠标右击
      rightMouseTop: 0,
      rightMouseLeft: 0,
      rightMouseFlag: false,

      showMessageLeft: false,
      showMessageRight: false,
    };
  },
  methods: {

    //图片右击
    rightShow(e) {
      this.rightMouseLeft = e.clientX
      this.rightMouseTop = e.clientY
      setTimeout(() => {
        this.rightMouseFlag = true
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false
      }, 2000);
      // this.$message('版权所有')
    },

    handleClose() {
      this.$emit('handleClose')
    },
    seeBigSmall() {
      this.switechValue = false
      console.log(1);
      this.seeFull = !this.seeFull
      this.$refs.imgPic.style.left = ''
      this.$refs.imgPic.style.top = ''
      if (this.seeFull) {
        fullScreen(this.$refs.imgBj)
        this.$refs.imgPic.style.cursor = 'zoom-out'
      } else {
        exitFullscreen()
        this.$refs.imgPic.style.cursor = 'zoom-in'
        // this.picTimes = 1
        // this.picDeg = 0
        // this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      }
    },
    //图片放大
    picLarge() {
      this.picTimes += 1.5;
      if (this.picTimes < 6) {
        this.$refs.imgPic.style.transform =
          "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
      } else {
        this.picTimes = 6;
        this.$refs.imgPic.style.transform =
          "scale(6) rotateZ(" + this.picDeg + "deg)";
      }
    },
    //图片缩小
    picSmall() {
      this.picTimes -= 1.5;
      if (this.picTimes > 1) {
        this.$refs.imgPic.style.transform =
          "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
      } else {
        this.picTimes = 1;
        this.$refs.imgPic.style.transform =
          "scale(1) rotateZ(" + this.picDeg + "deg)";
      }
    },

    //图片旋转
    picRotateLeft() {
      this.picDeg -= 90;
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
    },
    //图片旋转
    picRotateRight() {
      this.picDeg += 90;
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
    },

    //图片选用
    lovePic() { },

    //判断选中的图片在什么位置
    beSurePic(i, num) {
      if (i > num) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        this.scroll = i * -80;
        // console.log(piclistwidth - picalllistwidth)
        // console.log(this.scroll)
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 70;
          this.picCha = this.scroll;
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + ")";
        this.scroll = 0;
      }
    },

    //将图片删除
    deletePic() { },

    //将图片设为封面
    setIndexPic() { },

    //清除放大缩小效果
    clearLargeAndSmall() {
      this.$refs.imgPic.style.left = "";
      this.$refs.imgPic.style.top = "";
      this.picTimes = 1;
      this.picDeg = 0;
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
    },

    // //打开图片浏览
    // openDialog(i, e) {
    //   this.dialogVisible = true;
    //   this.choosePicMsg = {};
    //   // console.log(e)
    //   this.choosePicMsg.id = e.id;
    //   this.choosePicMsg.desc = e.desc || "暂无说明";
    //   this.choosePicMsg.src = e.picThumbW1080;
    //   this.choosePicMsg.myId = i;
    //   this.picAllListFlag = i;

    //   // this.getPicInfo(e)

    //   this.$nextTick(() => {
    //     this.clearLargeAndSmall();
    //     this.beSurePic(i, 10);
    //   });
    // },
    picListClick(e, i) {
      this.clearLargeAndSmall();
      this.choosePicMsg = e
      this.choosePicMsg.myId = i
      this.picAllListFlag = i;

    },

    //图片浏览中大的箭头 左边
    bigLeft() {
      if (this.choosePicMsg.myId === 0) {
        if (!this.showMessageLeft) {
          this.showMessageLeft = true
          setTimeout(() => {
            this.showMessageLeft = false
          }, 1500);
        }
        return;
      }

      this.clearLargeAndSmall();
      // if(this.choosePicMsg.id === this.picList.length - 1){
      //   return
      // }

      this.choosePicMsg = this.picList[this.choosePicMsg.myId - 1]
      this.getPicInfo(this.choosePicMsg)
      this.picAllListFlag = this.choosePicMsg.myId;
      if (this.choosePicMsg.myId < 10) {
        this.scroll = 0;
        this.picCha = -1;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.scroll = this.scroll + 3 * this.choosePicMsg.myId;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },

    //图片浏览中大的箭头 右边
    bigRight() {
      if (this.choosePicMsg.myId === this.picList.length - 1) {
        if (!this.showMessageRight) {
          this.showMessageRight = true
          setTimeout(() => {
            this.showMessageRight = false
          }, 1500);
        }
        return;
      }
      this.clearLargeAndSmall();
      // this.picListClick(this.picList[this.choosePicMsg.id + 1],this.choosePicMsg.id + 1)
      this.choosePicMsg = this.picList[this.choosePicMsg.myId + 1]
      this.getPicInfo(this.choosePicMsg)
      this.picAllListFlag = this.choosePicMsg.myId;
      // console.log(this.choosePicMsg)
      if (this.choosePicMsg.myId > 10) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        // console.log(this.scroll)
        // console.log(this.choosePicMsg.myId)
        if (this.scroll === 0) {
          this.scroll = this.choosePicMsg.myId * -70;
        } else {
          if (this.choosePicMsg.myId > 50) {
            this.scroll = this.scroll - 2 * this.choosePicMsg.myId;
          } else {
            this.scroll = this.scroll - 3 * this.choosePicMsg.myId;
          }
        }
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 80;
          setTimeout(() => {
            this.picCha = this.scroll;
          }, 1000);
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },

    //图片浏览小的箭头 右边
    smallRight() {
      let picalllistwidth = this.$refs.picalllist.offsetWidth;
      let piclistwidth = this.$refs.piclist.offsetWidth;
      this.scroll = this.scroll - 300;
      if (this.scroll < piclistwidth - picalllistwidth) {
        this.scroll = piclistwidth - picalllistwidth - 70;
        this.picCha = this.scroll;
        // console.log(this.scroll)
      }

      this.$refs.picalllist.style.transform =
        "translateX(" + this.scroll + "px)";

      // console.log(this.scroll)
    },
    //图片浏览小的箭头 左边
    smallLeft() {
      // let picalllistwidth = this.$refs.picalllist.offsetWidth
      // let piclistwidth = this.$refs.piclist.offsetWidth
      this.scroll = this.scroll + 300;
      if (this.scroll > 0) {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + "px)";
        this.scroll = 0;
      } else {
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }

      // console.log(this.scroll)
    },
    isJSON(str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            return false;
          }

        } catch (e) {
          console.log('error：' + str + '!!!' + e);
          return false;
        }
      }
      console.log('It is not a string!')
    },
    //获取图片信息
    getPicInfo(e) {
      // console.log(this.choosePicMsg);
      e.createAtMy = formatConversion(e.createAt.toString()).substring(0, 10)
      if (e.exif && this.isJSON(e.exif)) {
        e.exif = JSON.parse(e.exif)
      }
      if (e.exif) {
        if (e.exif.CreateAt) {
          e.createAtMyTake = formatConversion(e.exif.CreateAt.toString()).substring(0, 10)
        } else {
          e.createAtMyTake = ''
        }

        if (e.exif.format) {
          e.format = e.exif.format
        } else {
          if (e.fileInfo.savepath) {
            e.format = e.fileInfo.savepath.substring(e.fileInfo.savepath.length - 3)
          } else {
            e.format = '暂无'
          }

        }

        if (e.exif.ExposureTime) {
          e.ExposureTime = e.exif.ExposureTime
        } else {
          e.ExposureTime = '暂无'
        }

        if (e.exif.ISOSpeedRatings) {
          e.ISOSpeedRatings = e.exif.ISOSpeedRatings
        } else {
          e.ISOSpeedRatings = '暂无'
        }

        if (e.exif.FocalLength) {
          e.FocalLength = e.exif.FocalLength
        } else {
          e.FocalLength = '暂无'
        }

        if (e.exif.Make) {
          e.Make = e.exif.Make
        } else {
          e.Make = '暂无'
        }

      }
    },
  },
  created() {


    window.onresize = () => {
      if (!checkFull()) {
        // 退出全屏后要执行的动作
        // console.log("退出全屏")
        this.seeFull = false;
      }
    }
    this.choosePicMsg = this.passChoose
    //获取屏幕的宽度来控制列表的间距
    this.displayResolution = document.documentElement.clientWidth;
    this.getPicInfo(this.choosePicMsg)
    // console.log(this.choosePicMsg);
  },
};
</script>

<style lang="scss" scoped>
@import "./picViewRecycle.scss";
/deep/ .el-dialog__header {
  display: none;
}
/deep/ .el-dialog__body {
  display: flex;
  padding: 0;
}
</style>